import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './club-requests.action';
import { ClubRequests } from './club-requests.model';

export interface ClubRequestsRecordsState {
    listData: ClubRequests[];
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: ClubRequestsRecordsState = {
    listData: [],
    loading: false,
    error: null,
    total: 0
};

export const ClubRequestsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);